import { useEffect, useRef, useState } from 'react';
import Fade from 'react-reveal/Fade';
import { useTranslation, Trans } from "react-i18next";
import i18n from "i18next";
import m1m from '../../img/Home/mm1.webp';
import m2m from '../../img/Home/mm2.webp';
import m3m from '../../img/Home/mm3.webp';

import str from '../../img/Home/str.svg'
import str2 from '../../img/Home/str2.svg'

const images = [m1m, m2m, m3m];

const data = [
  { text: "home.81", text1: "home.78", text2: "home.79", text3: "home.80" },
  { text: "home.82", text1: "home.84", text2: "home.85", text3: "home.86" },
  { text: "home.83", text1: "home.87", text2: "home.88", text3: "home.89" },
];

function Projects() {

  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
    resetAutoSlide();
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    resetAutoSlide();
  };

  const resetAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
  };

  useEffect(() => {
    resetAutoSlide();
    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
      <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
        <div className="flex items-center justify-center">
          <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
            <Trans>{t('home.77')}</Trans>
          </p>
        </div>
        <div className='flex flex-col-reverse gap-y-[35px] xl:flex-row justify-between mt-[40px] xl:mt-[65px]'>
            <div>
                <Fade key={currentIndex}>
                    <p className='text-[#F26522] open-sans text-[16px] xl:text-[20px]'>{t(data[currentIndex].text1)}</p>
                    <p className='xl:max-w-[415px] mt-[10px] open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px]'>{t(data[currentIndex].text2)}</p>
                    <p className='xl:max-w-[415px] mt-[15px] open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px]'>{t(data[currentIndex].text3)}</p>
                </Fade>
            </div>
            <div>
                <div className='md:hidden flex flex-col'>
                    <div className='flex gap-[20px] justify-center'>
                        <div className='flex overflow-x-auto whitespace-nowrap gap-4 pb-2'>
                            {data.map((mmm, index) => (
                                <div key={index} className='shrink-0' onClick={() => setCurrentIndex(index)}>
                                    <p className={`${currentIndex === index ? 'text-[#F26522]' : 'text-[#F6F6F6]'}`}>
                                        {t(mmm.text1)}
                                    </p>
                                </div>
                            ))}
                        </div>
                        <div className='sm:hidden flex items-center gap-[10px] mt-[-5px]'>
                            <img src={str} alt="" className='flex-shrink-0'/>
                            <img src={str2} alt="" className='flex-shrink-0'/>
                        </div>   
                    </div>
                            
                    <Fade key={currentIndex}><img src={images[currentIndex]} className='h-[319px] sm:h-[400px] object-cover w-full mt-[30px]' alt="" /></Fade>
                </div>
                <div className="w-full xl:w-[720px] md:flex flex-col gap-y-[35px] mx-auto hidden">
                    <div>
                        <div className="flex justify-between gap-[8px] md:gap-[38px] xl:gap-0 h-[240px] md:h-[380px] items-end w-full transition-all duration-500 ease-in-out">
                        {[m1m, m2m, m3m].map((img, index) => {
                            const isActive = currentIndex === index;

                            return (
                            <div
                                key={index}
                                className={`relative overflow-hidden w-full transition-all duration-500 ease-in-out ${
                                isActive
                                    ? 'h-[240px] md:h-[380px] xl:w-[314px]'
                                    : 'w-[calc(100%-52%)] sm:w-[calc(100%-20%)] h-[150px] md:h-[200px] xl:w-[174px]'
                                }`}
                            >
                                <img
                                    src={img}
                                    alt=""
                                    className="absolute bottom-0 w-full h-auto min-h-full object-cover"
                                />
                                <div className="bglinmain w-full h-full absolute top-0 left-0"></div>
                                <div
                                className={`absolute bottom-[12px] left-[18px] transition-opacity duration-300 ${
                                    !isActive ? 'opacity-0 pointer-events-none xl:opacity-100 xl:pointer-events-auto' : ''
                                }`}
                                >
                                <p className="text-[18px] xl:text-[30px] text-[#F26522] relative">
                                    {data[index].title}
                                </p>
                                <p className="open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px]">
                                    <Trans>{data[index].text}</Trans>
                                </p>
                                </div>
                            </div>
                            );
                        })}
                        </div>
                    </div>
                    <div className="flex flex-row-reverse gap-[20px] items-end mb-[5px]">
                        <div className={`flex gap-[15px] ${i18n.language === 'ar' ? 'flex-row-reverse' : ''}`}>
                        <div
                            onClick={handlePrev}
                            className="w-[38px] xl:w-[50px] h-[38px] xl:h-[50px] hover:scale-[1.1] transition-all rounded-full border border-[#F6F6F6] flex items-center justify-center cursor-pointer"
                        >
                            <svg className="w-[18px] xl:w-[24px] h-[18px] xl:h-[24px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <path d="M21 12L3 12" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 15L3 12L6 9" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div
                            onClick={handleNext}
                            className="w-[38px] xl:w-[50px] h-[38px] xl:h-[50px] hover:scale-[1.1] rotate-180 transition-all rounded-full border border-[#F6F6F6] flex items-center justify-center cursor-pointer"
                        >
                            <svg className="w-[18px] xl:w-[24px] h-[18px] xl:h-[24px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <path d="M21 12L3 12" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 15L3 12L6 9" stroke="#F6F6F6" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        </div>
                        <div className="h-[1.5px] bg-[#F26522] w-full"></div>
                        <Fade key={currentIndex}>
                        <p className="open-sans text-[#F26522] text-[23px] xl:text-[30px]">0{currentIndex + 1}</p>
                        </Fade>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
